<!-- <alert type="info" class="text-center banner">Our facility will be closed on December 24th and 25th to celebrate Christmas, as well as on January 1st for New Year's Day.</alert> -->
<router-outlet></router-outlet>
<alert
      style="position: fixed; top: 4px; right: 4px ; z-index: 1000;"
      [dismissible]="alertService.dismissible()"
      [isOpen]="alertService.alertOpen()"
      [type]="alertService.alertType()"
      [dismissOnTimeout]="alertService.alertTimeout()"
      (onClosed)="alertService.alertOpen.set(false)"
    >
      <span class="pe-5"> {{ alertService.alertMsg() }} </span>
    </alert>
